<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- change password tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ t('Change Password') }}</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <b-tab active>
      <template #title>
        <feather-icon icon="GridIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ t('Customer Informations') }}</span>
      </template>

      <account-company-data />
    </b-tab>

    <b-tab active>
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ t('Personal Datas') }}</span>
      </template>

      <account-personal-data />
    </b-tab>

    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="KeyIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ t('Api Keys') }}</span>
      </template>

      <div>
        <b-button
          variant="primary"
          class="mb-1 mr-1"
          type="submit"
          @click="$bvModal.show('add-api-key-modal')"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{ t('Add New Api Key') }}
        </b-button>
      </div>

      <add-api-key-modal @loadItems="loadItems" />

      <template v-if="values && values.length">
        <account-api-keys
          v-for="(value, index) in values"
          :key="index"
          :values="value"
          @loadItems="loadItems"
        />
      </template>

      <div v-else class="border border-info rounded p-1 mb-1 text-center">
        {{ t('No data available') }}
      </div>
    </b-tab>

    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="FileIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">{{ t('My Documents') }}</span>
      </template>

      <div>
        <b-button
          variant="primary"
          class="mb-1 mr-1"
          type="submit"
          @click="$bvModal.show('add-customer-document-modal')"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{ t('Add New Document') }}
        </b-button>
      </div>

      <my-documents />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import AddApiKeyModal from '@/components/AddApiKeyModal.vue';
import useService from '@/auth/service/useService';
import AccountSettingPassword from './AccountSettingPassword.vue';
import AccountApiKeys from './AccountApiKeys.vue';
import AccountPersonalData from './AccountPersonalData.vue';
import AccountCompanyData from './AccountCompanyData.vue';
import MyDocuments from './MyDocuments.vue';

export default {
  components: {
    BTabs,
    BTab,
    BButton,
    AccountSettingPassword,
    AccountApiKeys,
    AddApiKeyModal,
    AccountPersonalData,
    AccountCompanyData,
    MyDocuments
  },
  data() {
    return {
      values: {},
      modalStatus: false
    };
  },

  created() {
    this.getAllApiKeys();
  },

  methods: {
    getAllApiKeys() {
      useService.getAllApiKeys().then(response => {
        this.values = response.data;
      });
    },

    loadItems() {
      this.getAllApiKeys();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
